// Make it possible to set the tenant via query param in dev mode
export default defineNuxtRouteMiddleware(async (to) => {
  const { tenant, initialize } = useTenant()
  await initialize()

  // For dev, allow setting the tenant via query param
  if (!import.meta.env.DEV) return

  const tenantQuery = to.query.tenant as string

  if (tenantQuery) {
    tenant.value = tenantQuery
  }
})
